<template>
  <main
    style="-webkit-box-flex: 1; -ms-flex: 1; flex: 1"
    class="container-fluid"
  >
  <button
    class="btn btn-default fa-pull-right"
    type="button"
    @click="panelOpen('ToggleUserModalOpen')"
    v-if="
    (UserInfo.mainUserDivNo == '9400400' ||
    UserInfo.mainUserDivNo == '9400500' ||
    UserInfo.mainUserDivNo == '5700400' ||
    UserInfo.divNo == '9400400'|| 
    UserInfo.divNo == '9400500'||
    UserInfo.divNo == '5700400') &&
    UserTokenKey
    && UserRight && UserRight.SWITCH_USER
    ">
    切換帳號
  </button>
    <section
      v-if="isSearch !== 'S'"
      class="container search"
      style="padding: 15px 0px 6px 0px;"
    >
      <div class="row">
        <div class="offset-1 col-8">
          <form class="form">
            <div class="input-group input-lg">
              <div class="input">
                <input
                  type="text"
                  name="Search"
                  id="Search"
                  class="form-control"
                  v-model="keyword"
                  @keydown.enter="doSearch()"
                  placeholder="輸入姓名、身分證、保單號碼進行搜尋..."
                  alt="ch"
                  style="width: 100%"
                  maxlength="40"
                  @input="checkKeyword"
                />
                <span id="searchclear" v-show="keyword" @click="cleanSearch()"
                  >清除</span
                >
              </div>
              <button
                class="btn btn-primary btn-icon"
                type="submit"
                @click.prevent="doSearch()"
              >
                <i class="icon-search i-24"></i>
              </button>
            </div>
          </form>
        </div>
      </div>
    </section>
    <section v-else class="container search" style="padding: 15px 0px 6px 0px">
      <div class="row">
        <div class="offset-1 col-9">
          <form class="form">
            <div class="input-group input-lg">
              <div class="input">
                <input
                  type="text"
                  name="Search"
                  id="Search"
                  class="form-control"
                  v-model="keyword"
                  @keydown.enter="doSearch()"
                  placeholder="輸入姓名、身分證、保單號碼進行搜尋..."
                  alt="ch"
                  maxlength="40"
                  @input="checkKeyword"
                />
                <span id="searchclear" v-show="keyword" @click="cleanSearch()"
                  >清除</span
                >
              </div>
              <button
                class="btn btn-primary btn-icon"
                type="submit"
                @click.prevent="doSearch()"
              >
                <i class="icon-search i-24"></i>
              </button>
            </div>
          </form>
        </div>
      </div>
    </section>
    <div v-if="isSearch == 'D'">
      <h4 class="text-green">戶長列表</h4>
      <div class="row">
        <h5 class="mt-3 mb-20 col-10">請選擇你想做建議的家庭</h5>
        <div class="col-2">
          <button 
            type="button"
            class="btn btn-primary float-right"
            @click="createCust()">
            建立新的家戶
          </button>
        </div>
      </div>
      <div class="row" v-if="getAllHouseholderBySalesResult.length != 0">
        <div
          class="col-md-3"
          v-for="(item, i) in getAllHouseholderBySalesResult"
          :key="`group-item-${i}`"
        >
          <div @click="saveUserItems(item)" class="card">
            <strong class="link text-underline m-0 font-24">{{
              truncate(item.name, 12)
            }}</strong>
            <div class="d-flex justify-content-end mt-10">
              <avatar
                class="mr-2"
                :gender="Number(item.sex)"
                :size="20"
                :height="20"
              />
              <strong>{{
                (item.age || item.age === 0 ? item.age : "--") + "歲"
              }}</strong>
            </div>
          </div>
        </div>
      </div>
      <div
        v-else
        class="text-center d-flex justify-content-center mt-5"
        colspan="6"
      >
        <div
          :class="{ 'h2w3 mt-4 section-loading': custsOfAgntIsLoading }"
        ></div>
        <h3 class="mb-3 pre-formatted">{{ this.remoteDataMessage }}</h3>
      </div>
    </div>
    <div v-else-if="isSearch == 'S'">
      <h4 class="text-green">
        搜尋結果
        <a class="btn btn-default btn-sm m-0 ml-3" @click="cleanSearch"
          >返回戶長列表</a
        >
      </h4>
      <div
        class="row mt-20"
        v-if="getFamilyMemberByConditionBnkResult.length != 0"
      >
        <div
          class="col-md-3"
          v-for="(item, i) in getFamilyMemberByConditionBnkResult"
          :key="`group-item-${i}`"
        >
          <div @click="saveUserItems(item)" class="card">
            <h4 class="link text-underline m-0 font-24">
              {{ truncate(item.name, 12) }}
            </h4>
            <div class="d-flex justify-content-end mt-10">
              <avatar
                class="mr-2"
                :gender="Number(item.sex)"
                :size="20"
                :height="20"
              />
              <strong>{{
                (item.age || item.age === 0 ? item.age : "--") + "歲"
              }}</strong>
            </div>
            <div class="mt-10" style="height: 44px; word-break: break-all">
              <span class="font-16">{{
                addFamilyName(item.familynamelist)
              }}</span>
            </div>
            <div class="d-flex justify-content-end" style="margin-top: 10px">
              <strong class="font-16">
                {{
                  `共${
                    item.familynamelist[0] == "(無成員)"
                      ? item.familynamelist.length
                      : item.familynamelist.length + 1
                  }人`
                }}
              </strong>
            </div>
          </div>
        </div>
      </div>
      <div
        v-else
        class="text-center d-flex justify-content-center mt-5"
        colspan="6"
      >
        <div
          :class="{ 'h2w3 mt-4 section-loading': custsOfAgntIsLoading }"
        ></div>
        <h3 class="mb-3 pre-formatted mr-5">{{ this.remoteDataMessage }}</h3>
      </div>
    </div>

    <Toggle-User-Modal
      :open="ToggleUserModalOpen"
      @close="panelClose('ToggleUserModalOpen')"
    />
    <mv-info :open="mvInfoOpen" @close="closeModal()" :showConfirmBtn="false">
      <div class="text font-20" slot="content">
        <div class="mt-10">因應資安要求，使用IE瀏覽器操作保單健檢功能會</div>
        <div>產生資料錯誤狀況，請改用Chrome瀏覽器開啟！</div>
      </div>
    </mv-info>
    <Legal-Warning-Modal
          :open="createCustWarningOpen"
          :message="warningMessage"
          :showCancel="false"
          @submit="proceedToCreate"
          @close="panelClose('createCustWarningOpen')"
        />   
  </main>
</template>

<script>
import moment from "moment";
import mvInfo from "@/desktop/views/mv/components/mvInfo";
import Avatar from "@/desktop/components/Avatar";
import ToggleUserModal from "./components/bkToggleUserModal";
import { mapActions } from "vuex";
import { commonMixin } from "@/mixins/common";
import { mapGetters } from "vuex";

import {
  getFamilyMemberByConditionBnk,
  getAllHouseholderBySales,  
} from "@/service";

import LegalWarningModal from "@/desktop/components/WarningModal4"; 

export default {
  name: "newBKMV",
  mixins: [commonMixin],
  data() {
    return {
      //判斷頁面與BUTTON
      isSearch: "D",
      //戶長列表
      getAllHouseholderBySalesResult: [],
      //搜尋結果
      getFamilyMemberByConditionBnkResult: [],
      //搜尋條件
      keyword: "",
      custsOfAgntIsLoading: false,
      custsOfAgnt: [],
      grpsOfAgnt: [],
      remoteDataMessage: "資料讀取中，請稍候...",
      //是否為保代用頁面
      isFromBank: true,
      ToggleUserModalOpen: false,
      //mvInfo Modal開闔
      mvInfoOpen: false,
      //個資法WarningModal
      createCustWarningOpen: false,
      warningMessage: '為確保客戶(準客戶)個人資料權益，請告知以下內容，並確實取得同意，為其進行資料建檔',    
           
    };
  },
  components: { Avatar, ToggleUserModal, mvInfo, LegalWarningModal },
  computed: {
    ...mapGetters(["CustInfo", "UserInfo", "UserTokenKey","UserRight"]),
  },
  methods: {
    moment,
    ...mapActions(["updateUserItems", "updateAllHolderSearchData"]),
    checkKeyword() {
      this.keyword = this.keyword.replace(/[^\u4e00-\u9fa5a-zA-Z0-9]/g, '');
      if (this.stringBytes(this.keyword, false, 40) > 40) {
        this.keyword = this.keyword.substring(0, this.stringBytes(this.keyword, true, 40));
      }
    },
    saveUserItems(item) {
      this.updateUserItems(item);
      localStorage.userItems = JSON.stringify(item);
      this.$router.push({ name: "bkRelation", });
    },
    cleanSearch() {
      this.keyword = "";
      this.isSearch = "D";
      this.init();
    },
    addFamilyName(familyNameList) {
      let str = "";
      familyNameList.forEach((familyItem, familyIndex) => {
        str +=
          familyIndex + 1 == familyNameList.length
            ? this.truncate(familyItem, 12)
            : this.truncate(familyItem, 12) + "、";
      });
      let result = this.truncate(str, 30);
      return result[result.length - 4] == "、" &&
        result[result.length - 1] == "."
        ? result.substring(0, result.length - 4) + "..."
        : result;
    },
    len(str) {
      return str.replace(/[^\x00-\xff]/g, "xx").length;
    },
    sub(str, n) {
      let l = 0;
      for (let i = 0; i < str.length; i++) {
        if (str[i].match(/[^\x00-\xff]/g)) {
          l += 2;
        } else {
          l++;
        }
        if (l >= n) {
          return str.substr(0, i + 1);
        }
      }
    },
    truncate(str, n) {
      if (str) {
        return this.len(str) > n ? this.sub(str, n) + "..." : str;
      } else {
        return "";
      }
    },
    doSearch() {
      if (this.keyword === "") {
        this.isSearch = "D";
        this.updateAllHolderSearchData([]);
        return;
      }
      this.isSearch = "S";
      this.getFamilyMemberByConditionBnkResult = [];
      this.remoteDataMessage = "資料讀取中，請稍候...";
      this.custsOfAgntIsLoading = true;
      getFamilyMemberByConditionBnk(
        this.$store.state.userInfo.id,
        this.keyword
      ).then((result) => {
        if (result.header && result.header.status == "200" && result.data) {
          this.getFamilyMemberByConditionBnkResult = result.data;
          this.updateAllHolderSearchData(result.data);
        } else {
          this.getFamilyMemberByConditionBnkResult = [];
          this.updateAllHolderSearchData([]);
        }

        this.remoteDataMessage = "查無歸戶資訊，請確認您輸入之資料是否正確";
        this.custsOfAgntIsLoading = false;
        this.registerHanlink(); // for 難字更新
      });
    },
    //新增客戶
    createCust() {
      this.panelOpen('createCustWarningOpen');
    },

    //個資法WarningModal
    proceedToCreate() {
      //20251216
      let agreeTime = window.moment().format("YYYY-MM-DD HH:mm:ss");
      this.panelClose('createCustWarningOpen');
      this.$router.push({
        name: "createBKCust2Family",
        params: {
          pdpaAgreeTime: agreeTime 
        },        
      });
    },

    formatDate(preDate) {
      if (preDate) {
        let dd = moment(preDate)
          .format("YYYY-MM-DD")
          .split("-");
        dd[0] = dd[0] - 1911;
        dd = dd.join("/");

        return dd;
      }
      return "";
    },
    init() {
      this.checkIsChrome();
      this.remoteDataMessage = "資料讀取中，請稍候...";
      this.custsOfAgntIsLoading = true;
      getAllHouseholderBySales(
        this.$store.state.userInfo.id,
        this.isFromBank
      ).then((result) => {
        if (result.header && result.header.status == "200") {
          this.getAllHouseholderBySalesResult = result.data;
        } else {
          this.$toast.info({
            title: result.header.message,
            timeOut: "10000",
          });
        }
        this.remoteDataMessage = "請「建立新的家戶」，才能開始使用保單健檢";
        this.custsOfAgntIsLoading = false;
        this.registerHanlink(); // for 難字更新
      });
    },
    checkIsChrome(){
      /* 判斷是否為IE瀏覽器
      let userAgent = navigator.userAgent;
      let isIE = userAgent.indexOf("compatible") > -1 && userAgent.indexOf('MSIE') > -1;
      let isIE11 = userAgent.indexOf('Trident') > -1 && userAgent.indexOf("rv:11.0") > -1;
      */
      let UA = navigator.userAgent
      let isChrome = UA.indexOf('Chrome') > -1 || UA.indexOf('CriOS') > -1 || UA.indexOf('Safari') > -1
      if(!isChrome)
         this.mvInfoOpen = true;
    },
    closeModal() {
      this.panelClose("mvInfoOpen");
    }
  },
  mounted() {
    this.init();
  },
};
</script>
<style lang="scss" scoped>
.card {
  flex: 1;
  margin-bottom: 10px;
  border-radius: 8px;
  padding: 10px 20px;
  border: 1px solid #989ca2;
  box-shadow: 0px 2px 2px 0px rgba(0, 0, 0, 0.15);
  .desc {
    vertical-align: middle;
    margin-right: 10px;
  }
}
.pre-formatted {
  white-space: pre;
}
#searchclear {
  position: absolute;
  right: 40px;
  top: 16px;
  bottom: 0;
  margin-right: 58px;
  cursor: pointer;
  font-size: 15px;
  color: #048f3a;
  text-decoration: underline;
}
.cardList {
  padding: 10px 20px 10px 20px;
  margin-right: 13px;
  margin-bottom: 20px;
  margin-left: 0px;
}
.cardSearch {
  margin-right: 17px;
}
.font-24 {
  font-size: 24px;
}
.font-16 {
  font-size: 16px;
}
.mt-10 {
  margin-top: 10px;
}
.mt-20 {
  margin-top: 20px;
}
.ml-44 {
  margin-left: 44px;
}
.ml-45 {
  margin-left: 45px;
}
.mb-20 {
  margin-bottom: 20px;
}
.h2w3 {
  height: 20px;
  width: 30px;
}
.cardCon {
  border-radius: 8px;
  box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.15);
  border: solid 1px #989ca2;
  background-color: #ffffff;
}
.w-120 {
  width: 120px;
}
.w-181 {
  width: 181px;
}
.h-44 {
  height: 44px;
}
.fw-600 {
  font-weight: 600;
}
.font-20 {
  font-size: 20px;
}

</style>
